import { render, staticRenderFns } from "./Objectives.vue?vue&type=template&id=0cc0fade"
import script from "./Objectives.vue?vue&type=script&lang=js"
export * from "./Objectives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports